export const ContentPath = 'https://content.chungchy.com/PhonicsHero/web_resource/';
export const ContentBookPath = 'https://content.chungchy.com/PhonicsHero/web_resource/book';
export const Mp3Path = '/flashCard/mp3/unit_01/';
export const Mp4Path = '/flashCard/mp4/';